import React, { useEffect, useState } from "react";
import { getDatabase, ref, set, get } from "firebase/database"; 
import { onAuthStateChanged, createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";



const SignUpForm = () => {

  const navigate = useNavigate();

 const [user, setUser] = useState(null);

  // Sign-Up state
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPassword, setSignupPassword] = useState("");
  const [signupUsername, setSignupUsername] = useState("");
  const [signupDisplayName, setSignupDisplayName] = useState("");
  const [signupError, setSignupError] = useState("");


  useEffect(() => {
    if (!window.bootstrap) {
      console.error("Bootstrap JS not loaded.");
    }

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return unsubscribe;
  }, []);
  
      if (user) {
        navigate("/", { replace: true });
        return;
      }

    const handleSignUp = async (e) => {
        e.preventDefault();
        setSignupError("");

        const validateEmail = (email) => /^[^@]+@\w+(\.\w+)+\w$/.test(email);
        const validatePassword = (password) => password.length >= 6;
        const validateField = (field) => field && field.length > 0;

        if (!validateEmail(signupEmail) || !validatePassword(signupPassword)) {
        setSignupError("Email or password is invalid.");
        return;
        }

        if (!validateField(signupUsername)) {
        setSignupError("Username is required.");
        return;
        }

        try {
            const database = getDatabase();

            // Check if username already exists
            const usersRef = ref(database, "USERS");
            const usersSnapshot = await get(usersRef);
            
            if (usersSnapshot.exists()) {
                const usersData = usersSnapshot.val();
                const usernameExists = Object.values(usersData).some(
                    (userData) => userData.USERNAME && userData.USERNAME.toLowerCase() === signupUsername.toLowerCase()
                );

                if (usernameExists) {
                    setSignupError("This username is already in use. Please choose another.");
                    return;
                }

                // Check if email alreadygoopledoop
                const emailExists = Object.values(usersData).some(
                    (userData) => userData.USEREMAIL && userData.USEREMAIL.toLowerCase() === signupEmail.toLowerCase()
                );

                if (emailExists) {
                    setSignupError("This email is already in use. Please use another email.");
                    return;
                }
            }

            // Generate USERURL from username
            const generateUserURL = (username) => {
                return username
                    .toLowerCase()
                    .replace(/\s+/g, "-")
                    .replace(/[^a-z0-9-]/g, "");
            };

            const userURL = generateUserURL(signupUsername);

            // Check if USERURL already exists
            if (usersSnapshot.exists()) {
                const usersData = usersSnapshot.val();
                const urlExists = Object.values(usersData).some(
                    (userData) => userData.USERURL && userData.USERURL === userURL
                );

                if (urlExists) {
                    setSignupError("This username format is already in use. Please choose a different username.");
                    return;
                }
            }

            const now = new Date();
            const SignUpformatted = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;

            const today = new Date();
            const USERLOGIN = `${String(today.getMonth() + 1).padStart(2, "0")}/${String(today.getDate()).padStart(2, "0")}/${today.getFullYear()}`;

            const userCredential = await createUserWithEmailAndPassword(auth, signupEmail, signupPassword);
            const user = userCredential.user;

            const user_data = {
                USEREMAIL: signupEmail,
                USERNAME: signupUsername,
                USERURL: userURL,
                USERLASTLOGIN: USERLOGIN,
                USERDISPLAYNAME: signupDisplayName,
                USERCREATEDDATE: SignUpformatted,
                USERCLASS: "FREE",
                USERISADMIN: "N",
                USERISVERYFIED: "N",
                USERACCOUNTCREATED: USERLOGIN,
            };

            await set(ref(database, "USERS/" + user.uid), user_data);

            const modal = window.bootstrap.Modal.getInstance(document.getElementById("SignUpModal"));
            modal.hide();

            setSignupEmail("");
            setSignupPassword("");
            setSignupUsername("");
            setSignupDisplayName("");
            setSignupError("");
        } catch (err) {
            // Handle Firebase authentication errors
            if (err.code === 'auth/email-already-in-use') {
                setSignupError("This email is already registered. Please use another email or login.");
            } else {
                setSignupError(err.message);
            }
        }
    };


   return (
    <div className="mt-5 mb-5">

       {user ? ( 
        <> 
         <p> You're already logged in. <Link to="/" className="text-primary"> Go to Home </Link>  </p>
        </>
      ) : ( 
        <>
            <h1 className="text-center mt-5"> Sign Up </h1>

            <div className="row justify-content-center">
              <div className="col-md-5">
                <div className="filter-section"></div>
              </div>
            </div>

            <div className="row justify-content-center mt-1">
                <div className="col-md-5">
                <label htmlFor="SignUp_Email" className="form-label">Email</label>
                <input type="email" className="form-control" id="SignUp_Email"
                  value={signupEmail} onChange={(e) => setSignupEmail(e.target.value)} />
                </div> 
            </div>

            <div className="row justify-content-center mt-1">
                <div className="col-md-5">
                <label htmlFor="SignUp_Password" className="form-label">Password</label>
                <input type="password" className="form-control" id="SignUp_Password"
                  value={signupPassword} onChange={(e) => setSignupPassword(e.target.value)} />
                </div> 
            </div>

            <div className="row justify-content-center mt-1">
                <div className="col-md-5">
                   <label htmlFor="SignUp_Username" className="form-label">Username</label>
                <input type="text" className="form-control" id="SignUp_Username"
                  value={signupUsername} onChange={(e) => setSignupUsername(e.target.value)} />
                </div> 
            </div>

            <div className="row justify-content-center mt-1">
                <div className="col-md-5">
                   <label htmlFor="SignUp_DisplayName" className="form-label">Display Name</label>
                     <input type="text" className="form-control" id="SignUp_DisplayName"
                  value={signupDisplayName} onChange={(e) => setSignupDisplayName(e.target.value)} />
                </div> 
            </div>

           <div className="row justify-content-center mt-1">
                <div className="col-md-5">
                 {signupError && <div className="text-danger mb-2">{signupError}</div>}
                </div> 
            </div>


            <div className="row justify-content-center mt-3">
              <div className="col-md-5 text-end">
              <button type="button" className="btn btn-primary" onClick={handleSignUp}>Sign Up</button>
              </div>
            </div>


            <div className="row justify-content-center mt-3">
              <div className="col-md-5 text-start">
               <p> Already have an account? <Link to="/Login" className="text-primary"> Login. </Link>  </p>
              </div>
            </div>
        </>
       )} 

      </div>

  );
};

export default SignUpForm;

